"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentImportController = /** @class */ (function () {
    function AdminStudentImportController($state, $stateParams, UsersModel, FlashService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
    }
    return AdminStudentImportController;
}());
AdminStudentImportController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
];
exports.default = AdminStudentImportController;
